import { Bell } from "@phosphor-icons/react";
import PropTypes from 'prop-types';

const ReminderButton = ({ 
  record, 
  handleBellClick, 
  canRemindField = 'reviewers', 
  disabledStatuses = ['APPROVED', 'REWORK'] 
}) => {
  // Determine if anyone can be reminded based on the field structure
  const getCanRemindArray = () => {
    if (canRemindField === 'reviewers') {
      return record.reviewers || [];
    } else if (canRemindField === 'workflow_visualization') {
      return record.workflow_visualization || [];
    }
    return [];
  };

  const canRemindArray = getCanRemindArray();
  const canRemindAnyone = canRemindArray.some(item => item.can_remind === true);
  const isDisabled = (record.status === "PENDING" && !canRemindAnyone) || 
                    disabledStatuses.includes(record.status) ||
                    record.status === "COMPLETED";

  if (isDisabled) {
    return (
      <button
        onClick={(e) => {
          e.stopPropagation();
        }}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: 0,
          weight: "light",
          color: "#999"
        }}
        aria-label="Send Reminder"
      >
        <Bell size={15} />
      </button>
    );
  }

  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        handleBellClick(record);
      }}
      style={{
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        padding: 0
      }}
      aria-label="Send Reminder"
    >
      <Bell size={15} />
    </button>
  );
};

ReminderButton.propTypes = {
  record: PropTypes.object.isRequired,
  handleBellClick: PropTypes.func.isRequired,
  canRemindField: PropTypes.oneOf(['reviewers', 'workflow_visualization']),
  disabledStatuses: PropTypes.arrayOf(PropTypes.string)
};

export default ReminderButton; 